import React from 'react';
import storage from '../../storage';
import { API_ROOT, getDefaultRequestHeaders } from '../../duck';

function withData(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        currentUrl: null,
        data: null,
        isFetching: false
      };
    }

    fetchData(url) {
      const { processResponse } = this.props;

      if (!storage.getItem(url)) {
        storage.setItem(url, fetch(`${API_ROOT}/${url}`, {
          headers: getDefaultRequestHeaders()
        })
          .then(response => {
            if (response.status >= 400) {
              // TODO: deal with bad response
            }
            return response.json();
          })
          .then(json => processResponse ? processResponse(json) : json));
      }

      storage.getItem(url)
        .then(data => {
          // TODO: this.mounted is an antipattern!!
          // refactor to https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
          if (this.mounted && this.state.currentUrl === url) {
            this.setState({ data, isFetching: false });
          }
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
      const { shouldComponentUpdate } = this.props;
      if (typeof shouldComponentUpdate === "function") {
          if (shouldComponentUpdate.call(this, nextProps, nextState)) {
            return true;
          }
      }

      return this.state.data !== nextState.data ||
        this.state.isFetching !== nextState.isFetching;
    }

    componentWillReceiveProps(nextProps) {
      const nextUrl = nextProps.url;
      if (this.props.url !== nextUrl) {
        this.setState({ currentUrl: nextUrl, isFetching: true });
        this.fetchData(nextUrl);
      }
    }

    componentDidMount() {
      const { url } = this.props;
      this.mounted = true;
      this.setState({ currentUrl: url, isFetching: true });
      this.fetchData(url);
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    render() {
      return <WrappedComponent {...this.props}
                               data={this.state.data}
                               isFetching={this.state.isFetching} />;
    }
  };
};

 export default withData;



// WEBPACK FOOTER //
// ./src/core/containers/withData/withData.js